import type { Markings } from 'chessboard/plugins/markings/config/types';

/**
 * Returns true if a marking is of a specific type. Function is curried for simpler
 * usage inside functional array methods.
 */
export function isType(type: string) {
  return function markingIsType(marking: Markings.Model) {
    return marking.type === type;
  };
}
